// src/pages/personal/analytics/FunnelPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import FunnelSection from './FunnelSection/FunnelSection';

const FunnelPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <FunnelSection />
    </AdaptiveLayout>
  );
};

export default FunnelPage;